'use client';

import { ComponentProps, useState } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import styles from './infoCard.module.scss';
import { Close } from '../../icons';

export const severityVariants = {
  info: styles.info,
  warning: styles.warning,
  error: styles.error,
  success: styles.success
} as const;

const infoCardClass = cva(styles.infoCard, {
  variants: {
    severity: severityVariants
  },
  defaultVariants: {
    severity: 'info'
  }
});

type InfoCardVariantProps = VariantProps<typeof infoCardClass>;

type InfoCardProps = ComponentProps<'div'> &
  InfoCardVariantProps & {
    onDismiss?: () => void;
    dismissable?: boolean;
  };

export default function InfoCard({
  className,
  children,
  severity = 'info',
  dismissable,
  onDismiss,
  ...props
}: InfoCardProps) {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) {
    return null;
  }

  return (
    <div className={infoCardClass({ className, severity })} {...props}>
      {children}
      {dismissable && (
        <button
          className={styles.dismiss}
          aria-label="dismiss"
          onClick={() => {
            setIsVisible(false);
            onDismiss?.();
          }}
        >
          <Close />
        </button>
      )}
    </div>
  );
}
